import { useSubscription } from "@apollo/client";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setRequestTrackerAC } from "@/messenger/actions/requestTracker";
import { RequestURIs } from "@/messenger/constants/requests";

import { createRequestTracker } from "@/messenger/models/requestTracker";
import { MessageTemplate, TopicType } from "@/messenger/types/graphql/autogenerated";
import { normalizeTopics } from "@/messenger/utils/normalize";
import { TMessageTemplatePlaceholder } from "src/types/entities/messageTemplate";
import { getTopicsSubscription } from "src/graphql/subscriptions";


export const sanitizeTopics = (topics: TopicType[]) => {
    //const result = topics?.filter(topic => topic?.contactCount >= 0);
    
    return topics;
};

const messageTemplateHelper = (messageTemplateString: string) => {
    return messageTemplateString
    .trim()
    .replace(/{{/g, "|||{{")
    .replace(/}}/g, "}}|||")
    .split("|||");
};

const messageTemplatePlaceholderHelper = (str: string[]): TMessageTemplatePlaceholder[] => {
    const placeholders = []
    str.forEach((item, i) => {
        if (item.includes("{{")) {
            const val = item.replace("{{", "").replace("}}", "");
            placeholders.push({ placeholder: val, indices: [i] });
          }
    });
    return placeholders;
}

const getMessageTemplate = (messageTemplates: MessageTemplate[]) => {
    const res = messageTemplates.map(messageTemplate => {
        const tempInArray = messageTemplateHelper(messageTemplate.template)
        const tempPlaceholder = messageTemplatePlaceholderHelper(tempInArray)
        return {
            ...messageTemplate,
            template: tempInArray,
            placeholders: tempPlaceholder
        }
    });
    return res;
}

const getTopicSubscription = () => {
    const dispatch = useDispatch();

    useSubscription(getTopicsSubscription, {
        onSubscriptionData: ({ subscriptionData }: any) => {
            try {
                const structuredTopicData = subscriptionData?.data?.topics?.map(data => {
                    return {
                        ...data,
                        messageTemplates: getMessageTemplate(data.messageTemplates)
                    }
                });
                
                const sanitizedTopics = sanitizeTopics(structuredTopicData);
                
                dispatch(normalizeTopics(sanitizedTopics));
    
                dispatch(setRequestTrackerAC(createRequestTracker(RequestURIs.GET_TOPICS, {
                    complete: true,
                    loading: false,
                    sent: true,
                })));
    
            } catch (e) {
                console.error(e);
            }
        },
    });

    useEffect(() => {
        dispatch(setRequestTrackerAC(createRequestTracker(RequestURIs.GET_TOPICS, {
            complete: false,
            loading: true,
            sent: true,
        })));
    }, []);

    return null;
};

export default getTopicSubscription;